import type { IAutoInvestCoinItem } from "@aspen/model";

export const IS_OPEN_MUTIPLE_LANGUAGE = false; // 语言显示

// 匹配任意数量的数字，允许有一个小数点和小数部分
export const TRADE_REGX_NUMBER = /^\d*\.?\d*$/;

// 匹配任意数量的整数
export const TRADE_REGX_NUMBER_INTEGER = /^\d*$/;

// 自定义DCA默认投资组合
export const DEFAULT_AD_PROPORTION: IAutoInvestCoinItem[] = [
  { currency: "BTC", percent: "65", select: true },
  { currency: "ETH", percent: "35", select: true },
];
// 语言配置
export const EN = "en";
export const ZH_CN = "zh";

export * from "./localStorageKeys";

// kyc个人/机构提交信息存储在一起，提交的时候需要分开提交，所以需要区分
// 定义个人KYC提交所需的字段列表
export const INDIVIDUAL_FIELDS = [
  "personalAnnualIncome",
  "liquidNetWorth",
  "percentageOfNetWorthInvestment",
  "sourceOfNetWorth",
  "employmentStatus",
  "investmentExperience",
  "expectedHoldingPeriod",
  "investmentObjective",
  "lossTolerance",
  "actionDownByPercent20",
  "nationality",
  "fileUrl",
];

// 机构负责人信息字段，director董事，beneficiary最终受益人
export const STAKEHOLDER_FIELDS = [
  "directorName",
  "directorEmail",
  "directorPhonePrefix",
  "directorPhone",
  "directorShareholding",
  "directorGender",
  "directorBirthDate",
  "directorNationality",
  "beneficiaryName",
  "beneficiaryEmail",
  "beneficiaryPhonePrefix",
  "beneficiaryPhone",
  "beneficiaryShareholding",
  "beneficiaryGender",
  "beneficiaryBirthDate",
  "beneficiaryNationality",
];

// 定义机构KYC提交所需的字段列表
export const INSTITUTION_FIELDS = [
  "expectedAnnualTurnover",
  "netAssetValue",
  "percentageOfNAVInvestment",
  "sourceOfNAV",
  "mainBusinessNature",
  "investmentExperience",
  "expectedHoldingPeriod",
  "investmentObjective",
  "lossTolerance",
  "actionDownByPercent20",
  "name",
  "businessNature",
  "brNumber",
  "companyRegistrationCountry",
  "contactAddress",
  "companyType",
  "fileUrl",
  ...STAKEHOLDER_FIELDS,
];
